<div class="container-fluid mt-4 px-3 pb-5" #container>
  <div class="container-shadow px-3 pt-5 pb-5" style="min-height: 100%">
    <div class="d-inline-block" style="position: fixed; right: 32px; bottom: 20px; z-index: 1039">
      <div class="card" #filterContainer>
        <div class="card-header" style="cursor: pointer" (click)="toggleFilter()">Filter Events <i class="fas" [ngClass]="{ 'fa-caret-down': showFilter, 'fa-caret-up': !showFilter }"></i></div>
        <div *ngIf="showFilter" class="list-group list-group-flush" style="cursor: pointer; overflow-y: scroll !important">
          <button style="cursor: pointer" type="button" class="list-group-item list-group-item-action" (click)="filterListSelect('event_types')">Event Type</button>
          <button style="cursor: pointer" type="button" class="list-group-item list-group-item-action" (click)="filterListSelect('attorneys')">Attorneys</button>
          <button style="cursor: pointer" type="button" class="list-group-item list-group-item-action" (click)="filterListSelect('staff')">Staff</button>
          <button style="cursor: pointer" type="button" class="list-group-item list-group-item-action" (click)="filterListSelect('locations')">Location</button>
          <button style="cursor: pointer" type="button" class="list-group-item list-group-item-action" [ngClass]="{ active: filterOptions.company }" (click)="filterOptions.company = !filterOptions.company; loadEvents()">PLO, P.C.</button>
          <button style="cursor: pointer" type="button" class="list-group-item list-group-item-action" [ngClass]="{ active: filterOptions.inactive }" (click)="filterOptions.inactive = !filterOptions.inactive">Inactive</button>
          <button style="cursor: pointer" type="button" class="list-group-item list-group-item-action" [ngClass]="{ active: filterOptions.recurring }" (click)="filterOptions.recurring = !filterOptions.recurring; loadEvents()">Recurring</button>
          <button style="cursor: pointer" type="button" class="list-group-item list-group-item-action" [ngClass]="{ active: filterOptions.shadow }" (click)="filterOptions.shadow = !filterOptions.shadow; loadEvents()">Shadow</button>
          <button style="cursor: pointer" type="button" class="list-group-item list-group-item-action" [ngClass]="{ active: filterOptions.placekeeper }" (click)="filterOptions.placekeeper = !filterOptions.placekeeper; loadEvents()">Place Keeper</button>
          <button style="cursor: pointer" type="button" class="border-bottom list-group-item list-group-item-action" (click)="clearAll()">Clear All</button>
        </div>
      </div>
    </div>
    <div class="d-inline-block" style="position: fixed; right: 190px; bottom: 20px; z-index: 1050">
      <div class="card" #filterItemsContainer [ngClass]="{ 'd-none': !showFilterItemsList }">
        <div class="card-header">
          <a class="text-dark font-weight-light float-right" style="cursor: pointer" (click)="$event.preventDefault(); $event.stopImmediatePropagation(); filterListSelect(null)">
            <span class="ti-close"></span>
          </a>
          {{ filterItemsListHeader }}
        </div>
        <div *ngIf="showFilterItemsList && filterItems" class="list-group list-group-flush" style="cursor: pointer; overflow-y: scroll !important">
          <button
            style="cursor: pointer"
            [ngStyle]="{ borderLeft: item.color ? '7px solid #' + item.color : 'none' }"
            *ngFor="let item of filterItems"
            type="button"
            class="list-group-item list-group-item-action mb-1 border-top-0 border-bottom-0"
            [ngClass]="{ 'bg-dark': item.selected, 'text-white': item.selected, 'bg-light': !item.selected }"
            (click)="toggleItemSelection(item)"
          >
            <i class="fas fa-check float-right" *ngIf="item.selected"></i>
            {{ item.name }}&nbsp;
          </button>
        </div>
      </div>
    </div>
    <div class="container" style="margin: 0px auto; min-height: 1000px">
      <div class="float-left">
        <button type="button" class="btn btn-primary" (click)="newEvent()"><i class="fas fa-plus"></i>&nbsp; Add Event</button>
      </div>
      <div class="float-right">
        <app-matter-search #matterSearch (matter_id)="this.filterOptions.matter_id = $event"></app-matter-search>
      </div>
      <div class="float-right">
        <div #reportrange id="reportrange" (bsValueChange)="dateChange($event)" bsDatepicker [bsConfig]="{ containerClass: 'theme-dark-blue' }" class="btn btn-outline-primary dropdown-toggle" style="margin-right: 10px">
          <i class="fas fa-calendar-alt"></i>
          &nbsp;
          <span class="dateranger"></span>
          <b class="caret"></b>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="py-2"></div>
      <div class="float-right">
        <div class="d-inline-block">
          <div class="input-group" *ngIf="isMultiDayView()">
            <div class="input-group-prepend">
              <span class="input-group-text">Show</span>
            </div>
            <select class="form-control" (change)="updateMultiday()" [(ngModel)]="multiDayNumberOfDays" name="multi_day_number_of_days">
              <option *ngFor="let numberOfDays of multiDayOptions" [value]="numberOfDays">
                {{ numberOfDays }}
              </option>
            </select>
            <div class="input-group-append">
              <span class="input-group-text">Days</span>
            </div>
          </div>
        </div>
        &nbsp;
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label class="btn btn-outline-primary" (click)="viewName = 'agendaDay'; checkInitialView()" [ngClass]="{ active: viewName == 'agendaDay' }"> <input type="radio" name="options" id="option1" autocomplete="off" [checked]="viewName == 'agendaDay'" /> Day </label>
          <label class="btn btn-outline-primary" (click)="viewName = 'multi-day'; updateMultiday()" [ngClass]="{ active: viewName == 'multi-day' }"> <input type="radio" name="options" id="option2" autocomplete="off" [checked]="viewName == 'multi-day'" /> Multi-day </label>
          <label class="btn btn-outline-primary" (click)="viewName = 'agnostic'; updateMultiday()" [ngClass]="{ active: viewName == 'agnostic' }"> <input type="radio" name="options" id="option-agnostic" autocomplete="off" [checked]="viewName == 'agnostic'" /> Agnostic </label>
          <label class="btn btn-outline-primary" (click)="viewName = 'agendaWeek'; checkInitialView()" [ngClass]="{ active: viewName == 'agendaWeek' }"> <input type="radio" name="options" id="option3" autocomplete="off" [checked]="viewName == 'agendaWeek'" /> Week </label>
          <label class="btn btn-outline-primary" (click)="viewName = 'month'; checkInitialView()" [ngClass]="{ active: viewName == 'month' }"> <input type="radio" name="options" id="option3" autocomplete="off" [checked]="viewName == 'month'" /> Month </label>
        </div>
      </div>
      <div [hidden]="isMultiDayView()">
        <app-full-calendar #fullCalendar [timeZone]="filterOptions.time_zone" [defaultView]="viewName" [filterOptions]="filterOptions" (showEvent)="eventShowReadonly = false; eventShowId = $event; openShowModal(event_show)" (events)="events = $event"></app-full-calendar>
      </div>
      <div [hidden]="!isMultiDayView()">
        <app-event-multiday [events]="events" [agnostic]="viewName == 'agnostic'"></app-event-multiday>
      </div>
    </div>
  </div>
</div>
<ng-template #event_form>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ eventFormTitle }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="editModalRef!.hide(); formResult('cancelled')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-event-form [eventId]="editingEventId" [eventDate]="newEventDate" [matterId]="matterId" (formResult)="formResult($event)" (showEvent)="eventShowReadonly = true; eventShowId = $event; openShowModal(event_show)"></app-event-form>
  </div>
</ng-template>
<ng-template #event_show>
  <div class="modal-header">
    <h4 class="modal-title">Event</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="showModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-event-show [eventId]="eventShowId" [modalMode]="true" [allowEdit]="!eventShowReadonly" (editEvent)="editingEventId = $event; showingEvent = true; openEditModal(event_form)"></app-event-show>
  </div>
</ng-template>
